module.exports = __webpack_public_path__ + "idea.png";